/* eslint-disable array-callback-return */
/* eslint-disable no-undef */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import Menu from '../../../../components/InternalMenu/Menu'

import { useForm } from "react-hook-form"

import { get, post } from '../../../../services/http'
import { notify } from '../../../../components/Toast'

import { ToastContainer } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

export default function index() {
  const navigate = useNavigate()
  const [resturants, setResturants] = useState([])
  const [categories, setCategories] = useState([])
  // eslint-disable-next-line no-unused-vars
  const [categorySelect, setCategorySelect] = useState()
  const [categoryList, setCategoryList] = useState([]) 
  const [pic, setPic] = useState()
  const [clickButton, setClickButton] = useState(false)
  
  document.title = 'ایجاد غذا یا نوشیدنی'

  const { register, handleSubmit } = useForm()

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/im/shops?token=${token}`)
      .then(respose => {
        setResturants(respose.data.data.docs)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })

    get(`/api/admin/im/categories/all?token=${token}`)
      .then(respose => {
        setCategories(respose.data.data.docs)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [token])

  const onSubmit = (data, e) => {
    e.preventDefault()
    setClickButton(true)

    let formData = new FormData()
    formData.append('pic', pic)
    formData.append('shop', data.shop)
    formData.append('category', data.category)
    formData.append('name', data.name)
    formData.append('price', data.price)
    formData.append('discountPrice', data.discountPrice)
    formData.append('level', data.level)
    formData.append('description', data.description)

    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    } 
    post(`/api/admin/im/foods?token=${token}`, formData, config).then(response => {
      notify('success', response.data.messageFa)
      setTimeout(() => {
        navigate('/im/foods')
      }, 2000)
    }).catch(error => {
      setClickButton(false)
      if (error) {
        notify('error', error)
      }
      notify('error', 'خطا در ارسال اطلاعات')
    })
  }

  const categoryHandler = (e) => {
    setCategorySelect(e.target.value)
    setCategoryList([])
    categories.map(item => {
      if (item.shop[0]._id === e.target.value) {
        setCategoryList(oldArray => [...oldArray, item])
      }
    })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'food'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right'>
              <div className='text'>
                ایجاد غذا یا نوشیدنی
              </div>
            </div>

            <div className='left'>
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * برای ایجاد غذا و یا نوشیدنی باید فیلد های زیر را پر کنید، برای تصویر غذا یا نوشیدنی از تصویر با کیفیت و نورپردازی شده استفاده کنید، تاثیر زیادی در کیفیت منو شما دارد.
            </div>
            <div className='lineTitleFood'>
              <hr />
              اطلاعات غذا یا نوشیدنی‌
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodName'>نام * :</label>
                <input id='foodName' {...register("name", { required: true, minLength: 3 })} type='text' placeholder='مثلا پیتزا' />
                <small id='foodNameAlert'>نام باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='foodPrice'>قیمت * :</label>
                <input id='foodPrice' {...register("price", { required: true, minLength: 3 })} className='ltrdirection' type='text' placeholder='25...' />
                <small id='foodPriceAlert'>قیمت باید وارد شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodLevele'>اولویت * :</label>
                <input id='foodLeveleDetails' {...register("level", { required: true })} type='number' />
                <small id='foodLeveleDetailsAlert'>اولویت باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='foodDiscountPrice'>قیمت با تخفیف * :</label>
                <input id='foodDiscountPrice' {...register("discountPrice", { required: true })} className='ltrdirection' type='text' placeholder='24...' />
                <small id='foodDiscountPriceAlert'>قیمت با تحفیف باید وارد شود</small>
              </div>
            </div>
            <div className="row">
              <div className='column'>
                <label htmlFor='resturantName'>انتخاب رستوران * :</label>
                <select id='resturantName' {...register("shop", { 
                  onChange: (e) => {categoryHandler(e)},
                  required: true })}>
                  <option id='none'>انتخاب کنید</option>
                  {resturants ? resturants.map((item, index) => {
                    return <option key={index} value={item._id}>{item.name}</option>
                  }) : ''}
                </select>
                <small id='resturantNameAlert'>رستوران باید انتخاب شود</small>
              </div>
              <div className='column'>
                <label htmlFor='categoryName'>انتخاب دسته بندی * :</label>
                <select id='categoryName' {...register("category", { required: true })}>
                  {categoryList ? categoryList.map((item, index) => {
                    return <option key={index} value={item._id}>{item.title}</option>
                  }) : ''}
                </select>
                <small id='categoryNameAlert'>رستوران باید انتخاب شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column textarea'>
                <label htmlFor='foodDetail'>توضیحات * :</label>
                <textarea id='foodDetail' rows={5} placeholder='توضیحات' {...register("description", { required: true })} />
                <small id='foodDetailAlert'>توضیحات باید وارد شود</small>
              </div>
            </div>
            <div className='lineTitleFood'>
              <hr />
              انتخاب عکس غذا یا نوشیدنی‌
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodPic'>عکس غذا یا نوشیدنی * :</label>
                <input id='foodPic' type='file'
                  onChange={e => {
                    const fileSelect = e.target.files[0]
                    setPic(fileSelect)
                  }} />
                <small id='foodPicAlert'>عکس باید انتخاب شود</small>
              </div>
            </div>
            <button className='createButton' type='submit' style={clickButton ? { backgroundColor: 'gray' } : {}} disabled={clickButton ? true : false}>{clickButton ? 'در حال آپلود ...' : 'ایجاد غذا یا نوشیدنی'}</button>
          </form>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
